import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const CollapseContentSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default CollapseContentSVG;
